import React from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";

export default function CarSection() {
  return (
    <>
    <Box component={'container'} >
      <Box sx={{
        display: 'flex',
        flexDirection: {lg: 'row', md: 'row', sm: 'column', xs: 'column'},
        justifyContent:{xl:'space-evenly',lg:'space-between'}
      }}>
      <Box>
        <Box >
          <img src="./images/Car.svg" alt="" width="100%" />
        </Box>
      </Box>


      {/* <Box > */}
        <Box sx={{paddingLeft: "24px"}}>
          <Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                lineHeight: {lg: "56px", md: "56px", sm: "56px", xs: "35px"},
                color: "#000000",
                // width: "526px",
                // Height: "112px",
                letterSpacing: "0.01em",
              }}
            >
              Where do you find your best meal plan
            </Typography>
            <Typography
              sx={{
                fontWeight: "400",
                // fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "16px"},
                fontSize:"18px",
                lineHeight: "145%",
                color: "##545359",
                // width: "528px",
                // Height: "52px",
                letterSpacing: "0.015em",
                marginTop: {lg: "0px", md: "0px", sm: "20px", xs: "20px"}
              }}
            >
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "32px",
              
            }}
          >
            <Box sx={{ paddingRight: "16px" }}>
              <img src="./images/cookedIcon.svg" alt="" />
            </Box>
            <Box >
              <Typography>Cooked by best catering chef</Typography>
              <Typography>
                Lorem Ipsum is simply dummy text of the printing{" "}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "32px",
            }}
          >
            <Box sx={{ paddingRight: "16px" }}>
              <img src="./images/delieveredIcon.svg" alt="" />
            </Box>
            <Box>
              <Typography>Cooked by best catering chef</Typography>
              <Typography>
                Lorem Ipsum is simply dummy text of the printing{" "}
              </Typography>
            </Box>
          </Box>
        </Box>
      {/* </Box> */}
      </Box>
      </Box>
    </>
  );
}
